import { withConfigServiceTNT } from './withConfigServiceTNT';
/**
 * @deprecated Use withConfigServiceTNT instead.
 */

export function withMagicApronTNT(BaseComponent, opts = {}) {
  const Deprecated = withConfigServiceTNT(BaseComponent, opts);
  Deprecated.displayName = 'withMagicApronTNT';
  return Deprecated;
}